/**
 * @file The short date of a report run's `scheduledAt`, such as "Oct 05".
 * Consumers: the Reports list's LAST RUN cell and the archive chips. It is
 * read in the calendar time zone, where the definition's hour lives, and in
 * the browser's zone while the calendar is unset.
 */
import { DateTime } from 'luxon';

const LOCALE = 'en-US';

export const analyticsReportDateText = (
  scheduledAt: string,
  timeZone: string | undefined,
): string =>
  DateTime.fromISO(scheduledAt, { zone: timeZone, locale: LOCALE }).toFormat(
    'LLL dd',
  );
